module.exports = __webpack_public_path__ + "img/06-top-img.5b623209.png";